package com.eladfinish.bible.contest.screens.monopoly

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.screens.monopoly.model.QuestionItemJsonKMP
import dev.icerock.moko.resources.ImageResource
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class MonopolyState(
    val pasukText: String,
    val diceImage: ImageResource,
    val isRolling: Boolean,
    val isRevealVisible: Boolean,
    val revealText: String,
    val fines: ImmutableList<String>,
    val prizes: ImmutableList<String>,
    val questions: ImmutableList<QuestionItemJsonKMP>,
    val isLoading: Boolean,
) : StateKt

sealed interface MonopolyAction : ActionKt {
    data object DiceClicked : MonopolyAction
    data object DiceRollFinished : MonopolyAction
    data object QuestionClicked : MonopolyAction
    data object PrizeClicked : MonopolyAction
    data object FineClicked : MonopolyAction
    data class StatementsLoaded(val fines: List<String>, val prizes: List<String>) : MonopolyAction
    data class QuestionsLoaded(val questions: List<QuestionItemJsonKMP>) : MonopolyAction
    data class LoadError(val message: String?) : MonopolyAction
}

sealed interface MonopolyEffect : EffectKt {
    data object PlayRollSound : MonopolyEffect
    data object PlayQuestionSound : MonopolyEffect
    data object PlayPrizeSound : MonopolyEffect
    data object PlayFineSound : MonopolyEffect
    data object VibrateShort : MonopolyEffect
    data object VibrateMedium : MonopolyEffect
    data object VibrateLong : MonopolyEffect
    data class ShowReveal(val text: String) : MonopolyEffect
    data object HideReveal : MonopolyEffect
    data class ShowToast(val message: String) : MonopolyEffect
}
